module.exports = __webpack_public_path__ + "img/szhxNo2.b62b17bb.png";